import type { ProcurementTopPart } from './types'

function formatPrice(n: number | null): string {
  if (n === null) return '—'
  if (Math.abs(n) >= 1000) return `${Math.round(n)}`
  return n.toFixed(2)
}

function TrendCell({ trend }: { trend: ProcurementTopPart['priceTrend'] }) {
  if (!trend) return <span className="text-gray-400">—</span>
  const cls =
    trend === 'up' ? 'text-red-600' : trend === 'down' ? 'text-emerald-600' : 'text-gray-500'
  const arrow = trend === 'up' ? '↑' : trend === 'down' ? '↓' : '—'
  return <span className={`tabular-nums ${cls}`}>{arrow}</span>
}

export function TopRequestedPartsTable({
  topParts,
  onRowClick,
}: {
  topParts: ProcurementTopPart[]
  onRowClick?: (target: { partNumber: string; brand: string | null }) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full">
      <div className="mb-1 text-sm text-gray-500">Топ запросов клиентами</div>
      <div className="text-[11px] text-gray-400 mb-3">Клик по строке → история цены</div>

      {topParts.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет данных за период</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-gray-500">
                <th className="text-left font-normal pb-2">Парт-номер</th>
                <th className="text-left font-normal pb-2">Бренд</th>
                <th className="text-right font-normal pb-2">Раз</th>
                <th className="text-right font-normal pb-2">Цена</th>
                <th className="text-right font-normal pb-2">Тренд</th>
              </tr>
            </thead>
            <tbody>
              {topParts.map((p) => (
                <tr
                  key={`${p.partNumber}-${p.brand ?? ''}`}
                  onClick={() => onRowClick?.({ partNumber: p.partNumber, brand: p.brand })}
                  className={`border-t border-gray-100 ${
                    onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''
                  }`}
                >
                  <td className="py-2 font-mono text-xs text-gray-900">{p.partNumber}</td>
                  <td className="py-2 text-gray-600">{p.brand ?? '—'}</td>
                  <td className="py-2 text-right tabular-nums">{p.requestsCount}</td>
                  <td className="py-2 text-right tabular-nums text-gray-700">
                    {formatPrice(p.currentPrice)}
                  </td>
                  <td className="py-2 text-right">
                    <TrendCell trend={p.priceTrend} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
